/** Split `arr` into chunks of at most `size` elements. */
export const chunk = <ItemType>(arr: readonly ItemType[], size: number): ItemType[][] =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_unused, i) => arr.slice(i * size, i * size + size));
